import axios from "axios";
import { toast } from "react-toastify";
import {
  CREATE_PRODUCT,
  DELETE_PRODUCT,
  GET_PRODUCT_DETAILS,
  GET_PRODUCT_LIST,
  UPDATE_PRODUCT,
} from "../constant/Type";
import { BASE_URL } from "../constant/URL";

//GET product LIST
export const getProductList = () => async (dispatch) => {
  try {
    const res = await axios.get(`${BASE_URL}/api/v1/products`, {
      withCredentials: true,
    });

    dispatch({
      type: GET_PRODUCT_LIST,
      payload: res.data.data,
    });
  } catch (err) {
    console.log(err);
  }
};

//GET product DETAILS
export const getProductDetails = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`${BASE_URL}/api/v1/products/${id}`, {
      withCredentials: true,
    });
    dispatch({
      type: GET_PRODUCT_DETAILS,
      payload: res.data.data,
    });
  } catch (err) {
    console.log(err);
  }
};

// CREATE product
export const createProduct = (values, image, images) => async (dispatch) => {
  const formData = new FormData();
  formData.append("name", values.name);
  formData.append("price", values.productPrice);
  formData.append("stock", values.stock);
  formData.append("description", values.description);
  formData.append("id", values.productId);

  if (image) {
    formData.append("primaryImage", image);
  }
  if (images) {
    for (let i = 0; i < images.length; i++) {
      formData.append(`images`, images[i]);
    }
  }
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    withCredentials: true,
  };
  try {
    // TODO ::: API CALL
    const res = await axios.post(
      `${BASE_URL}/api/v1/products`,
      formData,
      config
    );
    dispatch({
      type: CREATE_PRODUCT,
    });
    toast.success("product created successfully");
    dispatch(getProductList());
    return true;
  } catch (err) {
    console.log(err);

    return false;
  }
};

// Update product
export const updateProduct =
  (values, image, images, id) => async (dispatch) => {
    const formData = new FormData();
    formData.append("name", values.name);
    formData.append("price", values.productPrice);
    formData.append("stock", values.stock);
    formData.append("description", values.description);
    formData.append("id", values.productId);

    if (image) {
      formData.append("primaryImage", image);
    }
    if (images) {
      for (let i = 0; i < images.length; i++) {
        formData.append(`images`, images[i]);
      }
    }

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    };
    try {
      // TODO ::: API CALL
      const res = await axios.patch(
        `${BASE_URL}/api/v1/products/${id}`,
        formData,
        config
      );
      dispatch({
        type: UPDATE_PRODUCT,
      });
      toast.success("product updated successfully");
      dispatch(getProductList());
      return true;
    } catch (err) {
      toast.error(err.response.data.message);
      console.log(err);
      return false;
    }
  };

//DELETE  product
export const deleteProduct = (id) => async (dispatch) => {
  try {
    const res = await axios.delete(`${BASE_URL}/api/v1/products/${id}`);
    dispatch({
      type: DELETE_PRODUCT,
      payload: id,
    });
    dispatch(getProductList());
    return true;
  } catch (err) {
    console.log(err);

    return false;
  }
};
